import type { ReactNode } from 'react';
import { forwardRef, useCallback, useImperativeHandle, useState } from 'react';
import { twJoin } from 'tailwind-merge';

import { useOnClickOutside } from '../hooks';

type Props = {
  ButtonElement: ReactNode;
  children: ReactNode;
  className?: string;
};

export type DropDownInterface = {
  show: () => void;
  hide: () => void;
};

export const DropDown = forwardRef<DropDownInterface, Props>(({ ButtonElement, children, className }, ref) => {
  const [isVisible, setIsVisible] = useState(false);

  const contentRef = useOnClickOutside(
    useCallback(() => {
      setIsVisible(false);
    }, []),
  );

  const show = () => setIsVisible(true);
  const hide = () => setIsVisible(false);

  useImperativeHandle(ref, () => ({ show, hide }));

  return (
    <div className={twJoin('relative', className)}>
      <button type="button" onClick={() => setIsVisible(v => !v)} aria-expanded={isVisible}>
        {ButtonElement}
      </button>

      <div ref={contentRef} className={twJoin('absolute bg-surface-primary', isVisible ? 'block' : 'hidden')}>
        {children}
      </div>
    </div>
  );
});

DropDown.displayName = 'DropDown';
